export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/utils/getVariation.js
// module id = 238
// module chunks = 25